import { Component, OnInit, Input } from '@angular/core';
import { Channel } from '../FMAPI/channel';
import { UserPreferenceService } from '../user-preference/user-preference.service';

@Component({
  selector: 'app-show-master',
  templateUrl: './show-master.component.html',
  styleUrls: ['./show-master.component.css']
})
export class ShowMasterComponent implements OnInit {

  constructor(
    private UserPrefSvc: UserPreferenceService
  ) { }

  @Input() ResolveChannels: Channel[];

  ngOnInit() {
    let userPref = this.UserPrefSvc.Get();
    userPref.SelectedView = "master";
    this.UserPrefSvc.Set(userPref);
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/show-master/show-master.component.ts